// extracted by mini-css-extract-plugin
export var blogLink = "blogDetailBanner-module--blogLink--bf18e";
export var blog_banner = "blogDetailBanner-module--blog_banner--dd62d";
export var blog_banner_left = "blogDetailBanner-module--blog_banner_left--8d289";
export var blog_banner_right = "blogDetailBanner-module--blog_banner_right--89f32";
export var blog_banner_wrapper = "blogDetailBanner-module--blog_banner_wrapper--645ed";
export var blog_dt_tm = "blogDetailBanner-module--blog_dt_tm--ea677";
export var blogs_dt = "blogDetailBanner-module--blogs_dt--abc96";
export var blogs_social = "blogDetailBanner-module--blogs_social--38550";
export var dateDiv = "blogDetailBanner-module--dateDiv--eb107";
export var imgbox = "blogDetailBanner-module--imgbox--65302";
export var infoBox = "blogDetailBanner-module--infoBox--28d02";
export var infoDesig = "blogDetailBanner-module--infoDesig--26767";
export var infoName = "blogDetailBanner-module--infoName--42061";
export var twitter_icon = "blogDetailBanner-module--twitter_icon--01d61";
export var viewCount = "blogDetailBanner-module--viewCount--8eab5";
export var wrapperTitle = "blogDetailBanner-module--wrapperTitle--5c14b";